import React, { useEffect, useState } from "react";
import "./blog.css";
import noimage from "./assets/images/noimage.webp";

import blog3 from "./assets/images/Blog3.png";


import { Link } from "react-router-dom";

const slugify = (text) => {
  return text
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-");
};
export default function Blog() {
  const [activeCat, setActiveCat] = useState("all");
  const [blogs, setBlogs] = useState([]);
  const [visibleCount, setVisibleCount] = useState(6);

// Fetch blogs
useEffect(() => {
  fetch("https://rbuymart.rbhardwaj.com/server/api/admin/blog.php")
    .then((res) => res.json())
    .then((data) => {
    
console.log(data.data);
      const Blogdatewith = data.data.filter(
        (p) => new Date(p.date) <= new Date()
      );

      setBlogs(Blogdatewith);

      // ✅ react-snap prerender complete signal
      if (window.prerenderReady !== undefined) {
        window.prerenderReady = true;
      }
       
    })
    .catch((err) => {
      console.error("Error fetching blogs:", err);

      if (window.prerenderReady !== undefined) {
        window.prerenderReady = true;
      }
    });
}, []);

  const categories = [
    { id: "all", label: "All" },
    { id: "men", label: "Men's Wellness" },
    { id: "women", label: "Women's Wellness" },
    { id: "energy", label: "Energy & Strength" },
    { id: "sleep", label: "Better Sleep & Stress Relief" },
    { id: "bones", label: "Strong Bones & Joints" },
    { id: "heart", label: "Heart & Blood Sugar Support" },
    { id: "detox", label: "Detox & Weight Balance" },
    { id: "immunity", label: "Immunity & Everyday Health" },
    { id: "gut", label: "Gut & Digestion" },
    { id: "skin", label: "Skin, Hair & Beauty" },
  ];

  const filteredBlogs =
    activeCat === "all"
      ? blogs
      : blogs.filter((b) => b.category === activeCat);

  return (


    <>
     
       <div className="blog-page">
      {/* HERO SECTION */}
      <section className="hero">
       
      </section>
 <h1 style={{textAlign:'center',margin:'10px 0px'}}>Blog</h1>
      {/* CATEGORY FILTERS */}
      <section className="blogcategories">

        <div style={{width:'max-content',display:'flex'}}>
     {categories.map((c) => (
          <button
            key={c.id}
            className={activeCat === c.id ? "active" : ""}
            onClick={() => setActiveCat(c.id)}
          >
            {c.label}
          </button>
        ))}
        </div>
   
      </section>

      {/* BLOG LIST */}
      <section className="blog-container">

        {filteredBlogs.slice(0, visibleCount).map((blog, index) => (
    <div key={index} className="blog-card">
 <Link to={`/blog-detail/${slugify(blog.title)}`}>
              <picture>
      <source srcSet={blog.image || noimage} type="image/webp" />
      <source srcSet={blog.image || noimage} type="image/webp" />
        <img src={blog.image || noimage} alt={blog.title} width={400} height={300}/>
    </picture>
 </Link>

        
            <div className="blog-content">
              <div className="meta">
               Publish by {blog.author} | {blog.date} 
              </div>
              <div className="blog-title">{blog.title}</div>

              {/* Pass blog ID for detail page */}
              <Link to={`/blog-detail/${slugify(blog.title)}`}>
                <span className="read-more">Read more →</span>
              </Link>
            </div>
          </div>
))}
 
      </section>



    </div>
    {visibleCount < filteredBlogs.length && (
  <div style={{display:'flex'}}>

    
    <button
      className="load-more-btn"
      onClick={() => setVisibleCount((prev) => prev + 6)}
    style={{padding:'10px 20px',margin:'20px auto',backgroundColor:'rgba(39, 50, 114, 0.882)',color:'white',border:'none',borderRadius:'5px'}}>
      Load More
    </button>
  </div>
)}
    </>
 
  );
}
